var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuisness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 19.988,
    viewBox: "0 0 24 19.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4854",
    "data-name": "Rectangle 4854",
    width: 24,
    height: 19.988,
    transform: "translate(0 0)",
    fill: "#d13c3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10136",
    "data-name": "Group 10136",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10135",
    "data-name": "Group 10135",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5702",
    "data-name": "Path 5702",
    d: "M0,18.331V10.784a.544.544,0,0,1,.782-.22,2.029,2.029,0,0,0,1.194.421l8.023,0v1.474a.508.508,0,0,0,.5.526l3,0A.487.487,0,0,0,14,12.5l.01-1.515,8.018,0c.951,0,1.228-.7,1.694-.46a.5.5,0,0,1,.282.453l0,7.28a2.032,2.032,0,0,1-1.973,1.729L1.929,19.98A2.046,2.046,0,0,1,0,18.331",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5703",
    "data-name": "Path 5703",
    d: "M0,8.3V4.644A2.03,2.03,0,0,1,1.923,3L7,2.985l0-.929A1.994,1.994,0,0,1,8.908,0h6.183A1.977,1.977,0,0,1,17,2.009V2.99l4.933-.005a2.041,2.041,0,0,1,2.059,1.73L24,8.2a2.006,2.006,0,0,1-1.971,1.785l-8.016.007L14,9.488a.5.5,0,0,0-.5-.5h-3a.5.5,0,0,0-.5.5l-.012.5-7.92,0A2.067,2.067,0,0,1,0,8.3M15,2.989v-1H9v1Z",
    fill: "#d13c3c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuisness);
export default __webpack_public_path__ + "static/media/buisness.f283994550f43b8b095611a72068d08e.svg";
export { ForwardRef as ReactComponent };